module.exports = __webpack_public_path__ + "static/korobeinikiBeginningArranged-ca726d01fd0a7c79b61a4a03f8ef875d.mp3";